import { defineMessages } from "@formatjs/intl"

export const exportDisclaimerMessages = defineMessages({
	defaultDisclaimer: {
		defaultMessage:
			"Contains sensitive data and information. For internal use only within Porsche AG. In case of dual distribution: No forwarding of sensitive dealer data and information to those responsible for direct sales.",
		id: "exportDisclaimer.default",
	},
	localDealerManagerDisclaimer: {
		defaultMessage:
			"Contains sensitive data and information - no disclosure to other dealers or other third parties, not even in excerpts.",
		id: "exportDisclaimer.localDealerManager",
	},
	localMarketManagerDisclaimer: {
		defaultMessage:
			"Contains sensitive data and information - no disclosure to third parties, not even in excerpts.",
		id: "exportDisclaimer.localMarketManager",
	},
})
